/* Rquiere de mixin.js */

var storeRackSide = {
	data () {
		return {
			listStoreRackSides: [],
			methodsStoreRackSide: {
				create: 'register',
				get: 'storeRackSides',
				show: 'storeRackSide/',
			},
            objectStoreRackSide: {
                exist: 0,
                id: 0,
                name: '',
                color: '#000000',
                store_id: 0,
                store: {},
                store_rack_id: 0,
                store_rack: {},
                created_at: '',
                updated_at: ''
            },
			paginationStoreRackSides: [],
			searchStoreRackSides: '',
            searchingStoreRackSide: false,
			storeRackSideIdSelected: 0
		}
	},
	computed: {
	},
	filters: {
	},
	methods:{
		addStoreRackSideRowColumn(id, type) {
			let data = {
					type: type
				}
			let url = this.getApiBackend + this.methodsStoreRackSide.show + id + '/addRowColumn'
			console.log(url, data)
			this.axiosActionIS(url, 'POST', 'addStoreRackSideRowColumnResult', data)
		},
		addStoreRackSideRowColumnResult(response) {
			this.addStoreRackSideRowColumnResultLocal(response)
		},
		addStoreRackSideRowColumnResultLocal(response) {
			console.log('addStoreRackSideRowColumnResultLocal no desarrollado', response)
		},
		clearObjectStoreRackSide() {
			this.objectStoreRackSide.exist = 0
			this.objectStoreRackSide.id = 0
			this.objectStoreRackSide.name = ''
			this.objectStoreRackSide.color = '#000000'
			this.objectStoreRackSide.store_id = 0
			this.objectStoreRackSide.store = {}
			this.objectStoreRackSide.store_rack_id = 0
			this.objectStoreRackSide.store_rack = {}
			this.objectStoreRackSide.created_at = ''
			this.objectStoreRackSide.updated_at = ''
		},
		getAllStoreRackSides(page = 1) {
			this.searchingStoreRackSide = true
			this.listStoreRackSides = []
			let parameters = '?search=' + this.searchStoreRackSides + '&page=' + page
			this.axiosActionIS(this.getApiBackend + this.methodsStoreRackSide.get + parameters, 'GET', 'getAllStoreRackSidesResult')
        },
		getAllStoreRackSidesResult(response) {
			this.searchingStoreRackSide = false
			if(response.data.success == true) {
				this.listStoreRackSides = response.data.data
			}
            this.getAllStoreRackSidesResultLocal(response)
		},
        getAllStoreRackSidesResultLocal(response) {
            console.log('getAllStoreRackSidesResultLocal no desarrollado', response)
        },
		getStoreRackSide(id) {
			this.axiosActionIS(this.getApiBackend + this.methodsStoreRackSide.show + id, 'GET', 'getStoreRackSideResult')
		},
        getStoreRackSideResult(response) {
			if(response.data.success == true) {
				this.setObjectStoreRackSide(response.data.data)
			}
            this.getStoreRackSideResultLocal(response)
        },
        getStoreRackSideResultLocal(response) {
            console.log('getStoreRackSideResultLocal no está desarrollado', response)
        },
		getStoreRackSidesByStoreRackId(storeId) {
			this.searchingStoreRackSide = true
			this.listStoreRackSides = []
			let url = this.getApiBackend + 'storeRack/' + storeId + '/storeRackSides'
			this.axiosActionIS(url, 'GET', 'getStoreRackSidesByStoreRackIdResult')
		},
		getStoreRackSidesByStoreRackIdResult(response) {
			this.searchingStoreRackSide = false
			if(response.data.success == true) {
				this.listStoreRackSides = response.data.data
			}
			this.getStoreRackSidesByStoreRackIdResultLocal(response)
		},
		getStoreRackSidesByStoreRackIdResultLocal(response) {
			console.log('getStoreRackSidesByStoreRackIdResultLocal no desarrollado', response)
		},
		getStoreRackSideChildren(id) {
			this.searchingStoreRackSide = true
			let url = this.getApiBackend + this.methodsStoreRackSide.show + id + '/children'
			this.axiosActionIS(url, 'GET', 'getStoreRackSideChildrenResult')
		},
		getStoreRackSideChildrenResult(response) {
			this.searchingStoreRackSide = false
			this.getStoreRackSideChildrenResultLocal(response)
		},
		getStoreRackSideChildrenResultLocal(response) {
			console.log('getStoreRackSideChildrenResultLocal no desarrollado', response)
		},
		saveStoreRackSide(item) {
			let url = this.getApiBackend + this.methodsStoreRackSide.show + this.methodsStoreRackSide.create
            this.axiosActionIS(url, 'POST', 'saveStoreRackSideResult', item)
		},
		saveStoreRackSideResult(response) {
			if(response.data.success == true) {
				this.listStoreRackSides.push(response.data.data)
			}
			this.saveStoreRackSideResultLocal(response)
		},
		saveStoreRackSideResultLocal(response) {
			console.log('saveStoreRackSideResultLocal no desarrollado', response)
		},
        setObjectStoreRackSide(item) {
			for (const property in item) {
				this.objectStoreRackSide[property] = item[property]
			}
        },
	},
};

export default storeRackSide;